import Link from "@components/Link/Link";
import useGtmEvent from "@hooks/useGtmEvent";
import viewportState from "@stores/viewport";
import { useEffect, useState } from "react";
import { useSnapshot } from "valtio";

export default function ReadMore() {
  const [faqUrl, setFaqUrl] = useState<string>("");
  const { isTouchableDevice } = useSnapshot(viewportState);
  const sendGtmData = useGtmEvent();
  useEffect(() => {
    const host = window.location.origin;
    setFaqUrl(`${host}/faq?tab=gift`);
  }, []);
  return (
    <Link
      to={faqUrl}
      className="text-link-headline-hover underline hover:text-link-headline-hover"
      target={isTouchableDevice ? "_self" : "_blank"}
      onClick={() => {
        sendGtmData(
          "custom_event",
          "gift article",
          "click",
          "gift article info",
        );
      }}
    >
      了解更多
    </Link>
  );
}
